module.exports = __webpack_public_path__ + "static/media/line-columns.5dfd45b6.svg";